import { useHoliday } from './context';

const layer = { position: 'absolute', inset: 0, pointerEvents: 'none', overflow: 'hidden' } as const;

/**
 * Page layers, the first child of the app frame (Handoff section 3): particles behind the content
 * (z -1), and the decor overlay above it (z from the engine, 30; Chinese New Year 4) carrying the
 * sidebar ornament. Renders nothing for None. The z -1 layer sits above the frame background only
 * because the frame is `position: relative; isolation: isolate`.
 */
export function HolidayLayers() {
  const { hol } = useHoliday();
  if (!hol.show) return null;
  return (
    <>
      <div data-testid="holiday-back" aria-hidden="true" style={{ ...layer, zIndex: -1 }}>
        {hol.parts.map((p, i) => (
          <span key={i} className="hp" style={p.s} />
        ))}
      </div>
      <div data-testid="holiday-decor" aria-hidden="true" style={{ ...layer, zIndex: hol.z }}>
        <div style={hol.decor} />
      </div>
    </>
  );
}
